import { FilterItemType } from '@otp/ui';
import { TFunction } from 'i18next';
import { WttpQuestionnaireStatus } from 'src/graphql/generated/graphql';

export const getFilterConfig = ({ t }: { t: TFunction }) => [
  {
    id: 'status',
    size: 2,
    type: FilterItemType.Select,
    props: {
      inputProps: {
        placeholder: t('common.status.label'),
        variant: 'outlined',
        name: 'status',
        label: t('common.status.label'),
      },
      options: [
        {
          value: WttpQuestionnaireStatus.Active,
          name: t('common.active'),
        },
        {
          value: WttpQuestionnaireStatus.Draft,
          name: t('common.draft'),
        },
        {
          value: 'archived',
          name: t('common.archived'),
        },
      ],
    },
  },
];
